import * as React from "react";
import Box from "@mui/material/Box";
import { PieChart } from "@mui/x-charts";
import { Divider, Typography } from "@mui/material";
import OrdersMargemCard from "./OrdersMargem.component";

export default function CustomBarChart({ data }) {
  // Estado para controlar a visibilidade das linhas

  // Preparando os dados para o PieChart
  const pieData = Object.entries(data?.metodo_counts_total || {})
    // Ordenar os itens por valor (decrescente) e pegar os 5 primeiros
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5) // Pega os 5 maiores
    .map(([key, value]) => ({
      label: key,
      value: value,
    }));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      {/* OrdersMargemCard */}
      <Box sx={{ width: "auto" }}>
        <OrdersMargemCard data={data} />
      </Box>

      <Divider orientation="vertical" variant="middle" flexItem />

      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        rowGap="20px"
        sx={{
          backgroundColor: "#ffffff",
          padding: 3,
          borderRadius: 2,
          boxShadow: "2px 2px 8px rgba(0,0,0,0.06)",
        }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: 600, color: "#333" }}>
          Pedidos por Método de Pagamento
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: 4,
          }}
        >
          <PieChart
            series={[
              {
                data: pieData,
                highlightScope: { fade: "global", highlight: "item" },
                faded: {
                  innerRadius: 30,
                  additionalRadius: -30,
                  color: "#d3d3d3",
                },
                innerRadius: 30,
                outerRadius: 100,
                paddingAngle: 4,
                cornerRadius: 4,
                colors: ["#ff8b00", "#1e88e5", "#43a047", "#fdd835", "#8e24aa"],
              },
            ]}
            width={400}
            height={240}
          />
        </Box>
      </Box>
    </Box>
  );
}
